import { render, staticRenderFns } from "./SchedaMorteEdit.vue?vue&type=template&id=2cf92bb2&scoped=true"
import script from "./SchedaMorteEdit.vue?vue&type=script&lang=js"
export * from "./SchedaMorteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf92bb2",
  null
  
)

export default component.exports